import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LandingPage from './components/LandingPage';
import WorkLanding from './pages/WorkLanding';
import WorkPage from './pages/work/WorkPage';
import AIProjectsLanding from './pages/ai-projects/AIProjectsLanding';
import AIProjectPage from './pages/ai-projects/AIProjectPage';
import CaseStudyPage from './pages/case-studies/CaseStudyPage';
import GetInTouch from './pages/GetInTouch';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/work" element={<WorkLanding />} />
          <Route path="/ai-projects" element={<AIProjectsLanding />} />
          <Route path="/ai-projects/:id" element={<AIProjectPage />} />
          <Route path="/work/:id" element={<WorkPage />} />
          <Route path="/case-studies/:id" element={<CaseStudyPage />} />
          <Route path="/get-in-touch" element={<GetInTouch />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App; 